import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Loader2 } from 'lucide-react'

/**
 * Ruta para /ayudaventas. Accesible por cualquier usuario autenticado
 * (vendedores y admins). No monta el sidebar de administración: el módulo
 * Ayudaventas trae su propia cabecera y botón de salir.
 */
export default function SellerRoute() {
  const { user, loading, roleLoading } = useAuth()

  if (loading || (user && roleLoading)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <Loader2 className="h-12 w-12 animate-spin text-blue-500" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
